// import React from "react";
// import { Route, Routes } from "react-router-dom";
// import PrivateRoute from "../protectedRoute/PrivateRoute";
// import PublicRoute from "../protectedRoute/publicRoute";
// import Registration from "../pages/registration";
// // import Login from "../pages/login";
// // import Signup from "../pages/signup";
// import LandingPage from "../pages/landingPage";
// import EmailVerification from "../common/verification/emailVerification";
// import MobileVerification from "../pages/mobileVerification";
// // import CourseSelection from "../pages/courseSelection";
// import QueryList from "../pages/queryList";
// import EmailVerificationSuccess from "../common/verification/emailVerificationStatus";
// import MobileVerificationStatus from "../common/verification/mobileVerificationStatus";
// import RaiseQuery from "../pages/raiseQuery";
// // import PaymentReceiptList from "../pages/paymentReceiptList";
// import PaymentReceiptView from "../pages/paymentReceiptView";
// import { ForgetPassword } from "../pages/forgetPassword";
// import NewPasswordMail from "../pages/newPasswordMail";
// import ForgotPasswordStatus from "../common/verification/forgotpasswordStatus";
// import CandidateDetails from "../pages/candidateDetails";
// import CourseRegistration from "../pages/courseRegistration";
// import CourseSelection from "../pages/courseSelection";
// import PreRequestPage from "../pages/preRequestPage";
// import PaymentConfirmation from "../pages/paymentConfirmation";
// import Instruction from "../pages/instruction";
// import PaymentReciptList from "../pages/PaymentReciptList";
// import ObjectionTrackerDashboard from "../pages/ObjectionTrackerDashboard";
// import ObjectionTrackerView from "../pages/ObjectionTrackerView";
// import AnswerKey from "../pages/answerKeys";
// import AdmitCardList from "../pages/admitCardList";
// import AdmitCard from "../pages/admitCard";
// import ObjectionDetails from "../pages/objectionDetails";
// import BilldeskStatus from "../common/billdeskStatus";
// import VenueAllocation from "../common/venueAllocation";
// import PayUStatus from "../common/payuStatus";
// import ResetPassword from "../pages/resetPassword";
// import EditingFacility from "../pages/editingFacility";
// import ObjectionPaymentConfirmation from "../pages/ObjectionPaymentConfirmation";
// import ObjectionPayUStatus from "../common/ObjectionPayuStatus";
// import ObjectionBilldeskStatus from "../common/ObjectionbilldeskStatus";
// import ScoreCardList from "../pages/scoreCardList";
// import ScoreCard from "../pages/scoreCard";

// const CandidateRoutes = () => {
//   return (
//     <>
//       <Routes>
//       <Route path="" element={<LandingPage/>} />
//         {/* <Route path="" element={<PublicRoute><Login /></PublicRoute>} />
//         <Route path="login" element={<PublicRoute><Login /></PublicRoute>} />
//         <Route path="signup" element={<PublicRoute><Signup /></PublicRoute>} /> */}
//         <Route path="forgot-password" element={<PublicRoute><ForgetPassword /></PublicRoute>} />
//         <Route path="verify-email" element={<PublicRoute><EmailVerification /></PublicRoute>} />
//         <Route path="email-verified-status" element={<PublicRoute><EmailVerificationSuccess /></PublicRoute>} />
//         <Route path="mobileno-verification" element={<PublicRoute><MobileVerificationStatus /></PublicRoute>} />
//         <Route path="new-password" element={<PublicRoute><NewPasswordMail /></PublicRoute>} />
//         <Route path="forgot-password-status" element={<PublicRoute><ForgotPasswordStatus /></PublicRoute>} />
//         <Route path="verify-mobileno" element={<MobileVerification />} />
//         <Route path="home" element={<PrivateRoute><LandingPage /></PrivateRoute>} />
//         <Route path="registration" element={<PrivateRoute><Registration /></PrivateRoute>} />
//         <Route path="candidate-details" element={<PrivateRoute><CandidateDetails /></PrivateRoute>} />
//         <Route path="course-registration" element={<PrivateRoute><CourseRegistration/></PrivateRoute>}/>
//         {/* <Route path="course-selection" element={<PrivateRoute><CourseSelection /></PrivateRoute>} /> */}
//         <Route path="course-selection" element={<PrivateRoute><CourseSelection /></PrivateRoute>} />
//         <Route path="query-list" element={<QueryList />} />
//         <Route path="raise-query" element={<PrivateRoute><RaiseQuery /></PrivateRoute>} />
//         <Route path="pre-request" element={<PrivateRoute><PreRequestPage/></PrivateRoute>} />
//         <Route path="confirm-payment" element={<PrivateRoute><PaymentConfirmation/></PrivateRoute>} />
//         <Route path="instruction" element={<PrivateRoute><Instruction/></PrivateRoute>} />
//         <Route path="payment-receipts" element={<PrivateRoute><PaymentReciptList /></PrivateRoute>} />
//         <Route path="payment-receipt-view/:id" element={<PrivateRoute><PaymentReceiptView /></PrivateRoute>} />
//         <Route path="objection-tracker" element={<PrivateRoute><ObjectionTrackerDashboard /></PrivateRoute>} />
//         <Route path="objection-tracker-view" element={<PrivateRoute><ObjectionTrackerView /></PrivateRoute>} />
//         <Route path="objection-details" element={<PrivateRoute><ObjectionDetails/></PrivateRoute>} />
//         <Route path="answer-key" element={<PrivateRoute><AnswerKey /></PrivateRoute>} />
//         <Route path="pre-request" element={<PrivateRoute><PreRequestPage /></PrivateRoute>} />
//         <Route path="confirm-payment" element={<PrivateRoute><PaymentConfirmation /></PrivateRoute>} />
//         <Route path="objection-confirm-payment" element={<PrivateRoute><ObjectionPaymentConfirmation /></PrivateRoute>} />
//         <Route path="billdesk-status" element={<PrivateRoute><BilldeskStatus /></PrivateRoute>} />
//         <Route path="objection-billdesk-status" element={<PrivateRoute><ObjectionBilldeskStatus /></PrivateRoute>} />
//         <Route path="venue-allocation" element={<PrivateRoute><VenueAllocation/></PrivateRoute>} />
//         <Route path="payu-status" element={<PrivateRoute><PayUStatus /></PrivateRoute>} />
//         <Route path="objection-payu-status" element={<PrivateRoute><ObjectionPayUStatus /></PrivateRoute>} />
//         <Route path="instruction" element={<PrivateRoute><Instruction /></PrivateRoute>} />
//         <Route path="admit-card-list" element={<AdmitCardList/>} />
//         <Route path="score-card-list" element={<ScoreCardList/>} />

//         <Route path="admit-card" element={<AdmitCard/>} />
//         <Route path="score-card" element={<ScoreCard/>} />

//         <Route path="reset-password" element={<ResetPassword/>} />
//         <Route path="editing-facility" element={<EditingFacility />} />
//         {/* <Route path="payment-receipts" element={<PrivateRoute><PaymentReceiptList /></PrivateRoute>} /> */}
//         {/* <Route path="payment-receipt-view" element={<PrivateRoute><PaymentReceiptView /></PrivateRoute>} /> */}
//       </Routes>
//     </>
//   );
// };

// export default CandidateRoutes; 
import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import PrivateRoute from "../protectedRoute/PrivateRoute";
import PublicRoute from "../protectedRoute/publicRoute";
import SuspenseLoader from "../common/suspenseLoader"
const Registration = lazy(() => import("../pages/registration"));
const LandingPage = lazy(() => import("../pages/landingPage"));
const EmailVerification = lazy(() => import("../common/verification/emailVerification"));
const MobileVerification = lazy(() => import("../pages/mobileVerification"));
const QueryList = lazy(() => import("../pages/queryList"));
const EmailVerificationSuccess = lazy(() => import("../common/verification/emailVerificationStatus"));
const MobileVerificationStatus = lazy(() => import("../common/verification/mobileVerificationStatus"));
const RaiseQuery = lazy(() => import("../pages/raiseQuery"));
const PaymentReceiptView = lazy(() => import("../pages/paymentReceiptView"));
const ForgetPassword = lazy(() => import("../pages/forgetPassword"));
const NewPasswordMail = lazy(() => import("../pages/newPasswordMail"));
const ForgotPasswordStatus = lazy(() => import("../common/verification/forgotpasswordStatus"));
const CandidateDetails = lazy(() => import("../pages/candidateDetails"));
const CourseRegistration = lazy(() => import("../pages/courseRegistration"));
const CourseSelection = lazy(() => import("../pages/courseSelection"));
const PreRequestPage = lazy(() => import("../pages/preRequestPage"));
const PaymentConfirmation = lazy(() => import("../pages/paymentConfirmation"));
const CapPaymentConfirmation = lazy(() => import("../pages/cappaymentconfirmation"));
const Instruction = lazy(() => import("../pages/instruction"));
const PaymentReciptList = lazy(() => import("../pages/PaymentReciptList"));
const ObjectionTrackerDashboard = lazy(() => import("../pages/ObjectionTrackerDashboard"));
const ObjectionTrackerView = lazy(() => import("../pages/ObjectionTrackerView"));
const AnswerKey = lazy(() => import("../pages/answerKeys"));
const AdmitCardList = lazy(() => import("../pages/admitCardList"));
const AdmitCard = lazy(() => import("../pages/admitCard"));
const ObjectionDetails = lazy(() => import("../pages/objectionDetails"));
const BilldeskStatus = lazy(() => import("../common/billdeskStatus"));
const CapBilldeskStatus = lazy(() => import("../common/capbilldeskStatus"));
const VenueAllocation = lazy(() => import("../common/venueAllocation"));
const PayUStatus = lazy(() => import("../common/payuStatus"));
const CapPayUStatus = lazy(() => import("../common/cappayustatus"));
const ResetPassword = lazy(() => import("../pages/resetPassword"));
const EditingFacility = lazy(() => import("../pages/editingFacility"));
const ObjectionPaymentConfirmation = lazy(() => import("../pages/ObjectionPaymentConfirmation"));
const ObjectionPayUStatus = lazy(() => import("../common/ObjectionPayuStatus"));
const ObjectionBilldeskStatus = lazy(() => import("../common/ObjectionbilldeskStatus"));
const ScoreCardList = lazy(() => import("../pages/scoreCardList"));
const ScoreCard = lazy(() => import("../pages/scoreCard"));
const CapRegistartion = lazy(() => import("../pages/capRegistration"));
const CapCourseRegistration = lazy(() => import("../pages/capcourseRegistration"));

const CandidateRoutes = () => {
  return (
    <Suspense fallback={<SuspenseLoader />}>
      <Routes>
        <Route path="" element={<LandingPage />} />
        <Route path="forgot-password" element={<PublicRoute><ForgetPassword /></PublicRoute>} />
        <Route path="verify-email" element={<PublicRoute><EmailVerification /></PublicRoute>} />
        <Route path="email-verified-status" element={<PublicRoute><EmailVerificationSuccess /></PublicRoute>} />
        <Route path="mobileno-verification" element={<PublicRoute><MobileVerificationStatus /></PublicRoute>} />
        <Route path="new-password" element={<PublicRoute><NewPasswordMail /></PublicRoute>} />
        <Route path="forgot-password-status" element={<PublicRoute><ForgotPasswordStatus /></PublicRoute>} />
        <Route path="verify-mobileno" element={<MobileVerification />} />
        <Route path="home" element={<PrivateRoute><LandingPage /></PrivateRoute>} />
        <Route path="registration" element={<PrivateRoute><Registration /></PrivateRoute>} />
        <Route path="candidate-details" element={<PrivateRoute><CandidateDetails /></PrivateRoute>} />
        <Route path="course-registration" element={<PrivateRoute><CourseRegistration /></PrivateRoute>} />
        <Route path="course-selection" element={<PrivateRoute><CourseSelection /></PrivateRoute>} />
        <Route path="cap-registration" element={<PrivateRoute><CapRegistartion /></PrivateRoute>} />
        <Route path="query-list" element={<QueryList />} />
        <Route path="raise-query" element={<PrivateRoute><RaiseQuery /></PrivateRoute>} />
        <Route path="pre-request" element={<PrivateRoute><PreRequestPage /></PrivateRoute>} />
        <Route path="confirm-payment" element={<PrivateRoute><PaymentConfirmation /></PrivateRoute>} />
        <Route path="cap-confirm-payment" element={<PrivateRoute><CapPaymentConfirmation /></PrivateRoute>} />
        <Route path="instruction" element={<PrivateRoute><Instruction /></PrivateRoute>} />
        <Route path="payment-receipts" element={<PrivateRoute><PaymentReciptList /></PrivateRoute>} />
        <Route path="payment-receipt-view/:id" element={<PrivateRoute><PaymentReceiptView /></PrivateRoute>} />
        <Route path="objection-tracker" element={<PrivateRoute><ObjectionTrackerDashboard /></PrivateRoute>} />
        <Route path="objection-tracker-view" element={<PrivateRoute><ObjectionTrackerView /></PrivateRoute>} />
        <Route path="objection-details" element={<PrivateRoute><ObjectionDetails /></PrivateRoute>} />
        <Route path="answer-key" element={<PrivateRoute><AnswerKey /></PrivateRoute>} />
        <Route path="objection-confirm-payment" element={<PrivateRoute><ObjectionPaymentConfirmation /></PrivateRoute>} />
        <Route path="billdesk-status" element={<PrivateRoute><BilldeskStatus /></PrivateRoute>} />
        <Route path="cap-billdesk-status" element={<PrivateRoute><CapBilldeskStatus /></PrivateRoute>} />
        <Route path="objection-billdesk-status" element={<PrivateRoute><ObjectionBilldeskStatus /></PrivateRoute>} />
        <Route path="venue-allocation" element={<PrivateRoute><VenueAllocation /></PrivateRoute>} />
        <Route path="payu-status" element={<PrivateRoute><PayUStatus /></PrivateRoute>} />
        <Route path="cap-payu-status" element={<PrivateRoute><CapPayUStatus /></PrivateRoute>} />
        <Route path="objection-payu-status" element={<PrivateRoute><ObjectionPayUStatus /></PrivateRoute>} />
        <Route path="admit-card-list" element={<AdmitCardList />} />
        <Route path="score-card-list" element={<ScoreCardList />} />
        <Route path="admit-card" element={<AdmitCard />} />
        <Route path="score-card" element={<ScoreCard />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="editing-facility" element={<EditingFacility />} />
        <Route path="cap-landingpage" element={<CapCourseRegistration />} />
      </Routes>
    </Suspense>
  );
};

export default CandidateRoutes;
